class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    this.lockMobileSearch();

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  lockMobileSearch() {
    if (!this.matches('.header__search') || window.innerWidth >= 990 || this.mobileSearchLock) return;
    const body = document.body;
    this.mobileSearchLock = {
      y: window.scrollY,
      styles: Object.fromEntries(['position', 'top', 'left', 'right', 'width'].map(key => [key, body.style[key]])),
    };
    body.style.position = 'fixed';
    body.style.top = `-${this.mobileSearchLock.y}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    document.documentElement.classList.add('beyond-search-locked');
    this.viewportController = new AbortController();
    const update = () => {
      const viewport = window.visualViewport;
      const bottom = viewport ? viewport.height + viewport.offsetTop : window.innerHeight;
      this.style.setProperty('--beyond-search-visible-height', `${Math.max(160, Math.floor(bottom - 56))}px`);
    };
    const options = { signal: this.viewportController.signal, passive: true };
    window.visualViewport?.addEventListener('resize', update, options);
    window.visualViewport?.addEventListener('scroll', update, options);
    window.addEventListener('resize', update, options);
    update();
  }

  unlockMobileSearch() {
    if (!this.mobileSearchLock) return;
    this.viewportController?.abort();
    const lock = this.mobileSearchLock;
    this.mobileSearchLock = null;
    Object.entries(lock.styles).forEach(([key, value]) => { document.body.style[key] = value; });
    document.documentElement.classList.remove('beyond-search-locked');
    this.style.removeProperty('--beyond-search-visible-height');
    window.scrollTo({ top: lock.y, behavior: 'instant' });
  }

  disconnectedCallback() {
    this.unlockMobileSearch();
    document.body.removeEventListener('click', this.onBodyClickEvent);
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    this.querySelector('predictive-search')?.close();
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    this.unlockMobileSearch();
  }
}

customElements.define('details-modal', DetailsModal);
